import { render, staticRenderFns } from "./NewPlayer.vue?vue&type=template&id=ebb2fef8&scoped=true&"
import script from "./NewPlayer.vue?vue&type=script&lang=js&"
export * from "./NewPlayer.vue?vue&type=script&lang=js&"
import style0 from "./NewPlayer.vue?vue&type=style&index=0&id=ebb2fef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb2fef8",
  null
  
)

export default component.exports